//import numeral from 'numeral'
//import Immutable from 'immutable'

export function ThousandNum(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function isEmpty(obj) {
  return obj === null || obj === undefined || obj === "" || obj === "undefined";
}

export function dollarsFilter(value) {
  return `${ThousandNum(value).format("0,0")}円`;
}

export function cellDollarsFilter(value) {
  return `¥${ThousandNum(value).format("0,0")}`;
}

export function cellNumbersFilter(value) {
  return ThousandNum(value).format("0,0");
}


export function objToArr(obj) {
  return Object.keys(obj).map(function(key) { return obj[key]; });
}

export function reduceToFetch(array, promise) {
  return array.reduce((prev, curr) =>
    prev.then(prevResp =>
      promise(curr).then(resp => [...prevResp, resp])), Promise.resolve([]));
}
/*
export function immune(obj) {
  return Immutable.fromJS(obj, (key, value) => {
    const isIndexed = Immutable.Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toObject();
  });
}*/

export function refundStatus(value) {
  let name = "";
  switch (value) {
  case "CHARGED":
    name ="支払い済み";
    break;
  case "PARTIAL_REFUNDED":
    name="払戻済み（個別)";
    break;
  case "REFUNDED":
    name="払戻済み（全額)";
    break;
  case "CONFIRMING":
    name="購入失敗";
    break;
  default:
    name="";
  }
  return name;
}

export function commonTaxRateValue(arr,key) {
  let taxRateArr = arr.filter(item=>item.value==key);
  return taxRateArr.length >0 ?taxRateArr[0].label : "";
}

export function calculateTaxRateHandle(round,number) {
  let newNumber = number;
  switch (round) {
  case "ROUND":
    newNumber = Math.round(number);
    break;
  case "ROUND_UP":
    newNumber = Math.ceil(number);
    break;
  case "ROUND_DOWN":
    newNumber = Math.floor(number);
    break;
  default:
    newNumber = Math.ceil(number);
  }
  return newNumber;
}

export function eventUtilHandler(element,type,handler) {
  if(element.addEventListener) {
    return element.addEventListener(type,handler,false);
  }else if(element.attachEvent) {
    return element.attachEvent("on"+type,handler);
  }
  return element["on"+type]=handler;

}

export default {
  isEmpty,
  dollarsFilter,
  cellDollarsFilter,
  reduceToFetch,
  //immune,
  refundStatus,
  commonTaxRateValue,
  eventUtilHandler
};
